var _defs, _rect, _path, _path2, _circle, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel4A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-5{fill:none;}.cls-2,.cls-4{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5{stroke:#000;}.cls-2,.cls-3,.cls-5{stroke-miterlimit:10;}.cls-4,.cls-5{stroke-linecap:round;}.cls-4{stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 227,
    height: 457
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.2,256.37a15.41,15.41,0,0,0,4.88,3.48,7.14,7.14,0,0,0,5.85,0c3.42-1.77,4-6.53,3-10.25s-3.21-7.09-3.82-10.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.41,243.68a32.2,32.2,0,0,0-.7,9.72c.42,3.23,2,6.48,4.84,8.11s7,1.1,8.7-1.66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 104.85,
    cy: 231.48,
    r: 33.49
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.12,240.87a52.88,52.88,0,0,0,30-43.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.72,224.36a44,44,0,0,0,45.69,3.54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.62,230.56c0,6.54.14,10.24.66,16.55"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.96,
    cy: 245.29,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-2.62 1.05) rotate(-0.61)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.18,
    cy: 245.08,
    rx: 2.89,
    ry: 4.04,
    transform: "translate(-2.62 1.27) rotate(-0.61)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.76,347.57l-1.37,23.85a8.6,8.6,0,0,0,10.07,9L194.32,359.5a8.61,8.61,0,0,0,4.88-14.29l-15.54-17a8.66,8.66,0,0,0-6.94-2.79,746.24,746.24,0,0,0-104.18,14.2A8.6,8.6,0,0,0,65.76,347.57Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.79,286.71a12.69,12.69,0,0,0-8.4,3.92,1.13,1.13,0,0,0-.41.91c.08.45.6.63,1,.71a57.21,57.21,0,0,0,10.46,1.3,18.61,18.61,0,0,0,10-2.58C90.79,287.45,85.58,286.5,81.79,286.71Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.45,290.77c-2.47,19.48-4.92,39.28-1.69,58.65a20.68,20.68,0,0,0,2.15,7,8,8,0,0,0,5.74,4.15c3.28.37,6.37-2.11,7.75-5.11a17.81,17.81,0,0,0,1.36-7l3,2.07a6.07,6.07,0,0,0,1.73.9,1.91,1.91,0,0,0,1.83-.37,1.89,1.89,0,0,0,.43-1.83,5,5,0,0,0-.9-1.73,33.5,33.5,0,0,0-6.31-6.61c-.75-17.07-3.2-34.2-.65-51.07"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.37,279.75a39,39,0,0,0-9.28,2.16,13,13,0,0,0-7,6.18,44.58,44.58,0,0,0,14.31-4.86,6.67,6.67,0,0,0,1.81-1.3,2.41,2.41,0,0,0,.64-2.05C151.54,279.9,151.22,279.93,151.37,279.75Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138,286.53c7.25,12.79,14.58,25.77,18.29,40l.42,1.69a16,16,0,0,0-4.77,6,5.29,5.29,0,0,0-.53,1.9A2.33,2.33,0,0,0,152,338a2.48,2.48,0,0,0,2.86.08,8.78,8.78,0,0,0,2.17-2.13c.43-.52.88-1,1.35-1.51.22.66.45,1.31.72,1.95a15,15,0,0,0,6.51,7.65c3,1.56,7.09,1.43,9.57-.92,2.83-2.68,2.85-7.15,2.16-11-1.74-9.61-6.67-18.32-12-26.48s-11.21-16.07-15.22-25"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M102.15,256.63c2.21,0,7.35-.83,11.35-.59"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.58,256.8a5.66,5.66,0,0,0,3.43,2.57,2.58,2.58,0,0,0,2.31-.27,1.56,1.56,0,0,0,.48-1.38,3.73,3.73,0,0,0-.53-1.41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.68,327.51l4.79,3.24"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55,336.73l4.66,1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.63,348.65l5,.26"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181,318.6l4.15-7.52"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185.79,321.15l6.09-5.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M191.79,326.63l7-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel4A);
export default __webpack_public_path__ + "static/media/Idea_Panel_4a.53a9aae213a94d269a255aa561a649e4.svg";
export { ForwardRef as ReactComponent };